import { ILEGGELSE_SERVICE_BASE_URL } from "../config.ts";

export const GET_SINGLE_MOTORVOGN_BY_KJENNEMERKE_URL = `${ILEGGELSE_SERVICE_BASE_URL}/motorvogn`;
